/**
 * 预到关怀
 */
import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import { fetchTakeCareDetail } from '@/api/takeCare';
import ContentBlock from '@/components/Reservation/ContentBlock';
import useSafeState from '@/hooks/useSafeState';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkInByReserve';

// import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { rentRoomInfos } = state;
  let defaultOrderNo: string; // 默认子单id
  if (rentRoomInfos && rentRoomInfos.length) {
    // 2023/11/23 和预订备注一致取第一个
    defaultOrderNo = rentRoomInfos[0].recNo;
  }
  return {
    defaultOrderNo,
  };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
type MapStateProps = ReturnType<typeof stateSelector>;

const Index: React.FC<MapStateProps> = (props) => {
  const [contentText, setContentText] = useSafeState('');
  const { defaultOrderNo } = props;
  useEffect(() => {
    setContentText('');
    if (defaultOrderNo) {
      fetchTakeCareDetail({ recNo: defaultOrderNo }).then((res) => {
        if (res && res.data) {
          setContentText(res.data.content);
        }
      });
    }
  }, [defaultOrderNo]);

  return (
    <ContentBlock title={intl.get('drawer_checkin_pre_care_block_title')}>
      <div>{contentText || '—'}</div>
    </ContentBlock>
  );
};

export default connect<MapStateProps>(mapStateToProps)(memo(Index));
